<template>
  <div>
     <!-- 列表 -->
       <div class="comond_btn">
          <el-button  @click="handleSet('新增', null)" >新增</el-button>
      </div>
      <template>
        <el-table
          v-loading="loading"
          element-loading-text="加载中。。。"
          :data="list"
          style="width: 100%">

          <el-table-column
            label="创建时间">
            <template slot-scope="scope">
              <div>{{ formatime(scope.row.createDate) }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="仓储费用单价">
            <template slot-scope="scope">
              <div>{{ scope.row.warehouse }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="入库费用单价">
            <template slot-scope="scope">
              <div>{{ scope.row.storage }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="出库费用单价">
            <template slot-scope="scope">
              <div>{{ scope.row.depot }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="贴标费用单价">
            <template slot-scope="scope">
              <div>{{ scope.row.label }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="缠绕膜费用单价">
            <template slot-scope="scope">
              <div>{{ scope.row.filmWinding }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="保险费货值率">
            <template slot-scope="scope">
              <div>{{ scope.row.insurancePremium }}</div>
            </template>
          </el-table-column>
          <!-- 1，未结算，2已结算3开票4收款 -->
          <el-table-column
            width="320"
            label="操作选项">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="handleSet('删除', scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      <div style="text-align:center;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="(value) => {return handleSearch(5, value)}"
          :current-page="para.pageIndex"
          :total="total">
        </el-pagination>
      </div>
    </template>

    <!-- 弹框 -->
     <el-dialog
      :title="dialogPara.title"
      :visible.sync="dialogPara.isShowDialog"
      :width="dialogPara.width"
      center>
      <el-form :model="form">
        <!-- 新增 -->
        <template>
            <el-form-item label="仓储费用单价"><el-input v-model="form.warehouse"/></el-form-item>
            <el-form-item label="入库费用单价"><el-input v-model="form.storage"/></el-form-item>
            <el-form-item label="出库费用单价"><el-input v-model="form.depot"/></el-form-item>
            <el-form-item label="贴标费用单价"><el-input v-model="form.label"/></el-form-item>
            <el-form-item label="缠绕膜费用单价"><el-input v-model="form.filmWinding"/></el-form-item>
            <el-form-item label="保险费货值率"><el-input v-model="form.insurancePremium"/></el-form-item>
        </template>

      </el-form>
       <span slot="footer" class="dialog-footer">
          <el-button @click="dialogPara.isShowDialog = false">取 消</el-button>
          <el-button type="primary" @click="handleSucess">确 定</el-button>
      </span>
     </el-dialog>
  </div>
</template>

<script>
import { settlementlist, qiniugetDown, settlementadd, settlementdelete } from "../../api"
import utils from "../../../public/utils";
export default {
  data () {
    return {
      list: [],
      para: { //  查询条件
        status: '', //  状态
        pageIndex: 1, //  页码
        pageSize: 10 //  每页数量
      },
      dialogPara: { //  弹出框配置
        isshow: false, //  默认不显示参数
        isShowDialog: false, //  默认关闭弹出框
        title: '', //  弹出框标题
        rules: null, //  规则
        width: '50%',
      },
      form: {},
      total: 0,
      currentStatus: '',
      loading: true,
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleSet (type, val) {
      this.currentStatus = type
      this.dialogPara.title = type
       switch (type) {
        case '查看':
          this.form = val
          this.dialogPara.width = '30%'
          this.dialogPara.isShowDialog = true
          break
        case '新增':
          this.form = {}
          this.dialogPara.width = '30%'
          this.dialogPara.isShowDialog = true
          break
        case '删除':
          this.form = val
          this.$confirm('此操作将删除该条记录,是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then( () => {
            this.delete()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }).catch( () => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
       }
    },
    handleSucess () {
      switch (this.currentStatus) {
        case '查看':
          this.dialogPara.isShowDialog = false
          break
        case '新增':
          this.add()
          break
      }
    },
    add () {
      let para = new URLSearchParams(this.form)
      settlementadd(para).then(res => {
        console.log(res)
        let { code, data, msg } = res
        if (code === 10000) {
          this.getlist()
          this.dialogPara.isShowDialog = false
        } else {
          this.$message.error(msg)
        }
      })
    },
    delete () {
      let para = new URLSearchParams(this.form)
      settlementdelete(para).then(res => {
        console.log(res)
        let { code, data, msg } = res
        if (code === 10000) {
          this.getlist()
        } else {
          this.$message.error(msg)
        }
      })
    },
    handleSearch (type, val)  {
    },
    getlist () {
      this.loading = true
      settlementlist(this.para).then(res => {
        console.log(res)
        let { code, msg, data } = res.data
        if (code === 10000) {
          this.loading = false
          this.list = data.rows
          this.total = data.total
        } else {
          setTimeout( () => {
            this.loading = false
            this.$message.error('加载超时')
          }, 2000)
        }
        
      })
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
    downloadpdf (w) { // 下载
      console.log(w)
      let res = w.match(/http/g)
      if (res === null) {
        this.$message.error('该链接无效')
      } else {
        let para = new URLSearchParams()
        para.append('baseUrl', w)
        qiniugetDown(para).then(data => {
          console.log(data.data)
          window.open(data.data)
        })
      }
    },
    formatstatus (s) {
      // 1-未结算，2-已结算 3-开票  4-收款
      switch (s) {
        case 1:
          return '未结算'
        case 2:
          return '已结算'
        case 3:
          return '开票'
        case 4:
          return '收款'
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
.comond_btn
    display flex
    justify-content flex-end
    margin-bottom 30px
    button
      background-color #0a3d5f
      color #fff
.disflexbtw {
  display flex
  justify-content space-between
}
.el-form-item
  display flex
</style>
